<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <img src="../assets/img/Logo(1).png" height="32" class="m-2" alt="Interviewrr.ai company logo"/> <span class="custom-20px-500">Interviewrr</span>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CInput type="text" class="mt-3" placeholder="Search anything...." v-model="searchQuery" @input="highlightSearch"/>
     
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell"/>
        </CHeaderNavLink>
      </CHeaderNavItem> -->
    
     
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  data() {
    return {
      searchQuery: '', // Bind search input
    }
  },
  methods: {
    highlightSearch() {
    const query = this.searchQuery.trim();
    const content = document.getElementById('content');
    if (!content) return;

    // Reset previous highlights
    this.removeHighlights(content);

    if (query) {
      const regex = new RegExp(`(${query})`, 'gi');
      this.applyHighlights(content, regex);
    }
  },
  applyHighlights(container, regex) {
    container.childNodes.forEach((node) => {
      if (node.nodeType === 3) { // Text node
        const matches = node.nodeValue.match(regex);
        if (matches) {
          const span = document.createElement('span');
          span.innerHTML = node.nodeValue.replace(regex, '<span class="highlight">$1</span>');
          node.replaceWith(span);
        }
      } else if (node.nodeType === 1) { // Element node
        this.applyHighlights(node, regex);
      }
    });
  },
  removeHighlights(container) {
    const highlights = container.querySelectorAll('.highlight');
    highlights.forEach((highlight) => {
      const parent = highlight.parentNode;
      parent.replaceChild(document.createTextNode(highlight.textContent), highlight);
      parent.normalize(); // Merge adjacent text nodes
    });
  }
  }
}
</script>
